/**
 * cx - Class Name Utility
 *
 * A lightweight utility for conditionally joining class names.
 * Filters out falsy values and joins the remaining strings with spaces.
 *
 * @example
 * ```tsx
 * // Basic usage
 * cx('btn', 'btn-primary') // => 'btn btn-primary'
 *
 * // With conditionals
 * cx('btn', isActive && 'btn-active', isDisabled && 'btn-disabled')
 * // => 'btn btn-active' (if isActive=true, isDisabled=false)
 *
 * // With CSS modules
 * cx(styles.container, isOpen && styles.open, className)
 * ```
 *
 * @param classes - Class names or falsy values to conditionally include
 * @returns Joined class name string
 */
export function cx(
  ...classes: (string | false | null | undefined | 0 | "")[]
): string {
  return classes.filter(Boolean).join(" ");
}

export default cx;
